import RoleTable from "./roleTable.container";

export default RoleTable;